import { Box, Button, Flex, Heading, Image } from "@chakra-ui/react";
import { useState } from "react";
import successIcon from "../assets/success.svg"; // Corrected the import statement
import { CloseIcon } from "@chakra-ui/icons";

const EmployeeSuccess = ({onClose}) => {
  // const [display, setDisplay] = useState("flex");

  // const handleDisplay = () => {
  //   setDisplay("none");
  // };

  return (
      <Flex
        bg="#fff"
        maxW="400px"
        flexDirection="column"
        p="1rem"
        borderRadius="20px"
        boxShadow="rgba(151, 146, 146, 0.15) 5.4px 5.4px 6.2px"
        position="relative"
        onClick={(e) => e.stopPropagation()} 
      >
        {/* <Box position="absolute" top="10px" right="10px">
          <CloseIcon cursor="pointer" onClick={onClose} />
        </Box> */}
        <Box mt="5rem">
          <Image
            src={successIcon}
            alt="Employee uploaded successfully icon"
            mx="auto"
          />
        </Box>
        <Heading textAlign={"center"} as="h2" mt={5} fontSize={["18px", "28px"]} mb="3rem">
          Employee created successfully.
        </Heading>

        <Button mt={5} onClick={onClose}>Done</Button>
      </Flex>
  );
};

export default EmployeeSuccess;
